import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/proveedores")({
  beforeLoad: () => {
    throw redirect({ to: "/herramientas/proveedores", statusCode: 301 });
  },
});
